export default __webpack_public_path__ + "static/media/greentick.1426f72f.png";